import type { DocForLinking } from './docForLinkingType';
import type { DocsForLinkingIndex } from './docsForLinkingIndexType';

/**
 * Builds the Map index convertInternalLinks needs, from a plain array.
 *
 * Views carry docsForLinking as an array (see AbstractEntityView), so code that
 * only has a view — not the store — can index it itself. Kept in its own module,
 * free of store imports, so it can be used and tested standalone.
 */
export function toDocsForLinkingIndex(docs: DocForLinking[]): DocsForLinkingIndex {
  const byTemplateId = new Map<number, DocForLinking>();
  const byUuid = new Map<string, DocForLinking>();

  docs.forEach((doc) => {
    if (doc.templateId !== undefined) {
      byTemplateId.set(doc.templateId, doc);
    }
    byUuid.set(doc.uuid, doc);
  });

  return { byTemplateId, byUuid };
}
